<template>
  <table v-bind="$attrs">
    <thead>
      <tr>
        <th> Channel </th>
        <th v-if="ioMode == 3"> Manual </th>
        <th style="width: 100%; text-align: center;"> Value </th>
        <th> </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(channel, index) in channels">
        <ConfigureControllerAni
          :ioMode
          :port
          :portNumber
          :channel
          :channelMap
          :sensorModelConfigurationMode
          :channelNumber="channelOffset + index"
          @calibrate="openCalibrationDialog(channelOffset + index)"
        ></ConfigureControllerAni>
      </template>
    </tbody>
  </table>

  <CalibrationDialog v-if="selectedChannel"
    :port="port" 
    :portNumber="portNumber"
    :channel="selectedChannel"
    :channelNumber="selectedChannelNumber"
    :sensorModels="sensorModels"
    :sensorModelConfigurationMode="sensorModelConfigurationMode"
    @close="closeCalibrationDialog()">
  ></CalibrationDialog>

</template>

<script setup>
import { ref, computed, onUnmounted } from "vue";
import { useEventBus } from "@vueuse/core";
import store from "./store.js";
import CalibrationDialog from "./CalibrationDialog.vue";
import ConfigureControllerAni from "./ChannelConfigurationAni.vue";

let props = defineProps([
  "ioMode",
  "port",
  "portNumber",
  "channels",
  "channelOffset",
  "channelMap",
  "sensorModelConfigurationMode"
]);

let sensorModels = computed(() => {
  let session = store.sessions[0];
  return session.system.controller.sensorModels.children;
});

let selectedChannelNumber = ref(null);
let selectedChannel = computed(() => {
  return props.port.analogInputs.children[selectedChannelNumber.value];
});

function openCalibrationDialog(channelNumber) {
  selectedChannelNumber.value = channelNumber;
}

function closeCalibrationDialog() {
  selectedChannelNumber.value = null;
}

let eventBus = useEventBus("calibrationDialog");
eventBus.on(eventBusHandler);

// https://github.com/vueuse/vueuse/issues/3498
onUnmounted(() => eventBus.off(eventBusHandler));

function eventBusHandler(event) {
  if (event == "nextChannel") {
    selectedChannelNumber.value += 1;
    if (selectedChannelNumber.value  % 8 == 0)
      selectedChannelNumber.value = null;
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
}
:deep(th), :deep(td) {
  padding: 10px;
  text-align: left;
  border-bottom: 1px dashed #ccc;
  white-space: nowrap;
}
</style>